const toFiniteTime = (value) => {
  const numeric = Number(value)
  return Number.isFinite(numeric) ? numeric : null
}

/**
 * Select the lyric line whose first word started most recently.
 *
 * This deliberately ignores line end times. Adjacent lines can overlap when
 * backing vocals or the next phrase begin before the previous phrase ends.
 */
export const getActiveWordLevelLineIndex = (wordLevel, currentTime) => {
  if (!Array.isArray(wordLevel) || wordLevel.length === 0) return -1

  const playbackTime = toFiniteTime(currentTime)
  if (playbackTime === null) return -1

  let firstValidIndex = -1
  let activeIndex = -1
  let latestStart = Number.NEGATIVE_INFINITY

  wordLevel.forEach((line, index) => {
    const firstSegment = line?.segments?.[0]
    const lineStart = toFiniteTime(firstSegment?.start_time)
    if (lineStart === null) return

    if (firstValidIndex === -1) firstValidIndex = index
    if (lineStart <= playbackTime && lineStart >= latestStart) {
      latestStart = lineStart
      activeIndex = index
    }
  })

  return activeIndex === -1 ? firstValidIndex : activeIndex
}
